import { render, staticRenderFns } from "./AddBlocks.vue?vue&type=template&id=0fca8cb1"
import script from "./AddBlocks.vue?vue&type=script&lang=js"
export * from "./AddBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports